module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/fiesta-island-800.123c9413f2543b1a.jpg"+" 800w",
        images: [{path: "https://static.sniffspot.com/packs/img/fiesta-island-800.123c9413f2543b1a.jpg",width: 800,height: 614}],
        src: "https://static.sniffspot.com/packs/img/fiesta-island-800.123c9413f2543b1a.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/fiesta-island-800.123c9413f2543b1a.jpg"},
        
        width: 800,
        height: 614
      }